<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-container fluid>
          <template v-for="(item, index) in value">
            <v-flex xs12 class="text-center" :key="index">
              <v-text-field
                :type="item.type"
                :step="item.type === 'number' ? '1' : false"
                :pattern="item.type === 'number' ? '\\d*' : false"
                :label="item.label"
                :hint="item.hint"
                :suffix="item.suffix"
                v-model="item.value"
                @input="updateMessage"
                :inputmode="item.type === 'number' ? 'numeric' : 'text'"
                :append-icon="item.qr ? 'mdi-qrcode-scan' : ''"
                @click:append="openQrReader(item)"
              ></v-text-field>
            </v-flex>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="qrDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3 class="text-center">Les av QR-kode</h3>
        </v-card-title>
        <v-card-text>
          <qrcode-stream v-if="qrDialog" @decode="qrRead" @init="onInit" :camera="camera">
            <v-btn @click="switchCamera" outline icon>
              <v-icon>mdi-camera-switch</v-icon>
            </v-btn>
          </qrcode-stream>
          <h5 class="text-center mt-2">Pek kameraet mot QR-koden for å lese av denne</h5>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="qrDialog=false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  props: ["value"],
  data() {
    return {
      qrDialog: false,
      currentQrItem: null,
      error: null,
      camera: 'rear'
    };
  },
  methods: {
    updateMessage(e) {
      this.$emit("update-fields");
    },
    openQrReader(item) {
      this.qrDialog = true;
      this.currentQrItem = item
    },
    qrRead(qr) {
      this.currentQrItem.value = qr
      this.qrDialog = false
    },
    switchCamera () {
      switch (this.camera) {
        case 'front':
          this.camera = 'rear'
          break
        case 'rear':
          this.camera = 'front'
          break
      }
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
        this.$emit("error", this.error);
      }
    }
  }
};
</script>
